import type { FC } from "react";
import KemUnavailableScreen from "./components/KemUnavailableScreen";

const KemUnavailablePage: FC = () => {
  return (
    <div className="flex h-full w-full items-center justify-center px-5">
      <KemUnavailableScreen />
    </div>
  );
};

export default KemUnavailablePage;
